export default "__VITE_ASSET__BlsN2YKd__"